<template>
  <span class="icon-text">
    <img v-if="icon !== ''" class="mr-s" :src="icon" :alt="text" />
    <span v-text="text" />
  </span>
</template>

<script>
/**
 * Vue: icon-text (icon-text)
 * -----------------------------------------------------------------------------
 * Simple Component with an icon and text.
 *
 * @param {String} text - Text to be displayed next to icon.
 * @param {String} icon - Url of the icon.
 */
export default {
  name: 'IconText',

  props: {
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      cnvsGlobal: true,
    };
  },
};
</script>

<style lang="scss">
@import './icon-text';
</style>
